import axios from 'axios';
import { PortalConfig, DeviceInfo } from '../types/portal';
import { API_ENDPOINTS } from '../config/api.config';

/**
 * 后端BaseResponse格式
 */
interface BaseResponse<T> {
  code: number;
  message: string;
  data: T;
}

/**
 * 获取Portal配置，后台会生成带设备信息的服务号二维码
 */
export async function getPortalConfig(deviceInfo: DeviceInfo): Promise<PortalConfig> {
  try {
    console.log('API_ENDPOINTS.PORTAL.CONFIG', API_ENDPOINTS.PORTAL.CONFIG);
    const response = await axios.get<BaseResponse<PortalConfig>>(API_ENDPOINTS.PORTAL.CONFIG, {
      params: deviceInfo,
    });
    console.log('response', response);
    
    // 后端返回的是BaseResponse格式，需要从data字段中提取
    if (response.data.code === 0 && response.data.data) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || '获取配置失败');
    }
  } catch (error) {
    console.error('获取Portal配置失败:', error);
    throw error;
  }
}

